export const msConfig = {
    serviceInstance: new Object()
}


// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/modals/modalService.config.ts